import React, { useState, useEffect, useRef } from 'react';
import { Calendar, DayValue } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import { ReactComponent as CalendarIcon } from '@/assets/img/calendar-icon-v2-grey.svg';
import moment from 'moment';
import Utils from '@/utils/util';
import { useClickOutside } from './UseClickOutside';
import Portal from './Portal';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon-new-v2.svg';
import { min } from 'lodash';

interface Props {
  value?: string;
  onChange: (date: DayValue) => void;
  placeholder?: string;
  maximumDate?: DayValue;
  minimumDate?: DayValue;
  disabled?: boolean;
  validateData?: boolean;
  showInput?: boolean;
}

const DatePickerWithPortal: React.FC<Props> = ({
  value,
  onChange,
  placeholder = 'Pick a date',
  maximumDate,
  minimumDate,
  disabled,
  validateData = false,
  showInput = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const calendarRef = useRef(null);

  const toggleCalendar = () => {
    setIsOpen((prev) => !prev);
  };

  useClickOutside([inputRef, calendarRef], () => {
    setIsOpen(false);
  });

  return (
    <>
      {showInput ? (
        <span ref={inputRef} className="datepicker-container" onClick={toggleCalendar}>
          <input
            type="text"
            placeholder={placeholder}
            readOnly
            disabled={disabled}
            value={value ? moment(value).format('DD-MMM-YYYY') : placeholder}
            className={`cust-input-mobile ${
              value ? '' : validateData ? 'placeholder-text empty' : 'placeholder-text'
            }`} // a styling class
          />
          <CalendarIcon />
        </span>
      ) : (
        <span ref={inputRef} className="datepicker-container" onClick={toggleCalendar}>
          <EditIcon />
        </span>
      )}
      {isOpen && (
        <Portal className="datepicker-center-container">
          <div className="datepicker-wrapper" ref={calendarRef}>
            <button onClick={() => setIsOpen(false)} className="close-btn" aria-label="Close">
              <span role="img" aria-label="Close calendar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="gray"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </span>
            </button>
            <Calendar
              maximumDate={maximumDate ? maximumDate : undefined}
              minimumDate={minimumDate ? minimumDate : undefined}
              onChange={(date) => {
                onChange(date);
                setIsOpen(false);
              }}
              value={value ? Utils.parseMMDDYYYY(value) : undefined}
              colorPrimary="#0fbcf9"
              calendarClassName="custom-calendar"
              calendarTodayClassName="custom-today-day"
            />
          </div>
        </Portal>
      )}
    </>
  );
};

export default DatePickerWithPortal;
